import { render, staticRenderFns } from "./tg1.vue?vue&type=template&id=7f6da306&scoped=true&"
import script from "./tg1.vue?vue&type=script&lang=js&"
export * from "./tg1.vue?vue&type=script&lang=js&"
import style0 from "./tg1.vue?vue&type=style&index=0&id=7f6da306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6da306",
  null
  
)

export default component.exports